import classes from "./index.module.css";

const FacebookID = ({ id }) => {
  const url = `https://facebook.com/${id}`;

  const openUrl = () => {
    window.open(url, "_blank");
  };

  return (
    <div className={classes.facebookID} onClick={() => openUrl()}>
      {id}
    </div>
  );
};

export default FacebookID;
